"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = _interopRequireDefault(require("../styles"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _EDSContext = require("../EDSContext/EDSContext");

var _tokens = require("../styles/tokens");

var _excluded = ["color", "classes", "edsContext", "label", "className", "theme"];

var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      margin: _tokens.spacing30
    },
    indicator: {
      width: _tokens.sizingXSmall,
      height: _tokens.sizingXSmall,
      borderRadius: _tokens.borderRadiusCircle,
      marginRight: _tokens.spacing20,
      alignSelf: 'center'
    }
  };
};
/**
 * A UI element that renders an indicator color and label for the CalendarLegend.
 * @done true
 * @updated false
 * @versionAdded v0.2.1
 * @lab true
 */


var CalendarLegendItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var color = props.color,
      classes = props.classes,
      edsContext = props.edsContext,
      label = props.label,
      className = props.className,
      theme = props.theme,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded); // default to the cta color if no color it sent for the indicator

  var indicatorColor = color === null || color === undefined ? theme.palette.tertiary.fountain[600] : color;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, rest, {
    ref: ref,
    dir: edsContext.dir
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.indicator,
    style: {
      backgroundColor: indicatorColor
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, label));
});

CalendarLegendItem.propTypes = {
  /**
   * The color to match the calendar items in this category.
   */
  color: _propTypes.default.string,

  /**
   * The label to render next to the indicator.
   */
  label: _propTypes.default.string.isRequired,

  /**
   * @ignore
   */
  classes: _propTypes.default.object,

  /**
   * Class name to send to parent `div` of the CalendarLegendItem.
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * Material-UI theme object.
   */
  theme: _propTypes.default.object
};
CalendarLegendItem.displayName = 'CalendarLegendItem';

var _default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles, {
  withTheme: true
})(CalendarLegendItem));

exports.default = _default;